// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-pages-EntityFiltersPage-AsyncTableView-TableSortingButtonSdt-TableSortingButtonSdt-module__sorter--gIrUU {
  background: none;
  border: none;
  box-shadow: none;
  display: flex;
  column-gap: 4px;
  justify-content: space-between;
  align-items: center;
  text-align: left;
  width: 100%;
}
.src-pages-EntityFiltersPage-AsyncTableView-TableSortingButtonSdt-TableSortingButtonSdt-module__sorter--gIrUU svg {
  cursor: pointer;
}
.src-pages-EntityFiltersPage-AsyncTableView-TableSortingButtonSdt-TableSortingButtonSdt-module__content--Q92lD {
  flex: 1;
  min-width: 0;
  line-height: 1.5;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  word-break: break-word;
  white-space: normal;
}
`, "",{"version":3,"sources":["webpack://./src/pages/EntityFiltersPage/AsyncTableView/TableSortingButtonSdt/TableSortingButtonSdt.module.less"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,aAAA;EACA,eAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;AACF;AAVA;EAWI,eAAA;AAEJ;AAEA;EACE,OAAA;EACA,YAAA;EACA,gBAAA;EAEA,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,aAAA;EACA,4BAAA;EACA,uBAAA;EAEA,sBAAA;EACA,mBAAA;AAFF","sourcesContent":[".sorter {\n  background: none;\n  border: none;\n  box-shadow: none;\n  display: flex;\n  column-gap: 4px;\n  justify-content: space-between;\n  align-items: center;\n  text-align: left;\n  width: 100%;\n  svg {\n    cursor: pointer;\n  }\n}\n\n.content {\n  flex: 1;\n  min-width: 0;\n  line-height: 1.5;\n\n  overflow: hidden;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  line-clamp: 3;\n  -webkit-box-orient: vertical;\n  text-overflow: ellipsis;\n\n  word-break: break-word;\n  white-space: normal;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"sorter": `src-pages-EntityFiltersPage-AsyncTableView-TableSortingButtonSdt-TableSortingButtonSdt-module__sorter--gIrUU`,
	"content": `src-pages-EntityFiltersPage-AsyncTableView-TableSortingButtonSdt-TableSortingButtonSdt-module__content--Q92lD`
};
export default ___CSS_LOADER_EXPORT___;
